import { render, staticRenderFns } from "./EventListingRoute.vue?vue&type=template&id=5e97605e&"
import script from "./EventListingRoute.vue?vue&type=script&lang=ts&"
export * from "./EventListingRoute.vue?vue&type=script&lang=ts&"
import style0 from "./EventListingRoute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports